var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2289 2.20939e-05C6.68344 0.00363217 6.24412 0.448738 6.24764 0.994193L6.27677 5.50627L1.84511 5.5356C1.29283 5.53925 0.848018 5.98992 0.851584 6.5422C0.855149 7.09447 1.30575 7.53921 1.85802 7.53556L6.28968 7.50623L6.31882 12.0186C6.32234 12.5641 6.76737 13.0034 7.31283 12.9997C7.85828 12.9961 8.2976 12.551 8.29408 12.0056L8.26495 7.49315L12.6973 7.46382C13.2496 7.46016 13.6944 7.00949 13.6908 6.45722C13.6873 5.90495 13.2367 5.46021 12.6844 5.46386L8.25204 5.4932L8.22291 0.98112C8.21939 0.435665 7.77435 -0.00358798 7.2289 2.20939e-05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIcon);
export default __webpack_public_path__ + "static/media/button_icon.fc50d7e50337a56193a698d56ddee64f.svg";
export { ForwardRef as ReactComponent };